import i18n from "i18n"
import { useQuery } from '@tanstack/react-query'
import { useApi } from "hooks"


const HEROS ={
  es: 'cb83f9ad-b8e3-4776-b2ec-2107bc111069',
  en: '3d194d8a-4b3a-4d1f-84d5-534dc72ab4de'
}


const useGetHero = () => {

  const { apiFetch } = useApi()

  const getHero = () => {
    const heroUUID = HEROS[i18n.language]

    const url = `/carrusels/${heroUUID}/series`

    return apiFetch({ url })
      .then(res => res.data.contents)
  }

  const options = {
    staleTime: 60000 * 30, // 30 min
    placeholderData: []
  }

  return useQuery(['hero', 'series', 'lang'], getHero, options)
}

export default useGetHero